/** @jsxImportSource theme-ui */

import { Typography } from 'components/_common/Typography';

const BepiDisclaimer = () => {
  return (
    <Typography data-testid="bepi-disclaimer" variant="caption" color="stone70" marginBottom="0">
      The epidemic preparedness index is a static measure of potential resilience to all infectious
      disease threats in a given location. It should be considered along with other contextual
      factors and may not fully represent vulnerability in all outbreak scenarios.
    </Typography>
  );
};

export default BepiDisclaimer;
